import PageContainer from 'components/common/PageContainer/PageContainer';
import { TreeProgramTopHeader } from 'components/common';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { MilestoneFragnetFilter } from 'components/common/GlobalFilterComponent/components/MilestoneFragnetFilter/MilestoneFragnetFilter';
import { GlobalFilterButton } from 'components/common/GlobalFilterButton/GlobalFilterButton';
import { excellenceAppsConfig } from 'components/Dashboards/ExcellenceApps/excellenceAppsConfig';
import { GlobalFilterComponent } from 'components/common/GlobalFilterComponent/GlobalFilterComponent';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ActivitiesPredecessors } from 'components/widgets/ActivityCompletionPlan/activitiesPredecessors';

export const CompletionPlanPage = () => {
    useFullStoryPageView({ pageName: excellenceAppsConfig.completionPlan.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <TreeProgramTopHeader pageTitle={excellenceAppsConfig.completionPlan.title}>
                    <GlobalFilterButton />
                </TreeProgramTopHeader>
                <GlobalFilterComponent defaultValues={{ milestoneFragnet: null }}>
                    <MilestoneFragnetFilter name={'milestoneFragnet'} />
                </GlobalFilterComponent>
            </HeaderWrapper>
            <MainContent>
                <PageWidgetWrapper>
                    <ActivitiesPredecessors />
                </PageWidgetWrapper>
            </MainContent>
            <MainCardRoutingModal queryKeys={['activityCompletionPlan']} />
        </PageContainer>
    );
};
